import { IRootState, RootState } from '../root-state.store';
// @ts-ignore
import { IBlockService } from '@/services';
import { ActivityStatus } from '../../common/enums';
import { BlockService } from '../../services';
import { BlockDto, BlockParameter, IBlockParameter, IBlockListingViewModel, IBlock } from '../../models/block';
import { ITicketListingViewModel } from '../../models/ticket';
import { IPagination, Pagination } from '../../models/generic';
import { IBaseFilterParameter } from '../../models/base-filter.parameter';
import { BLOCK_LOADERS } from './block-types.store';
import { AddressDto } from '../../models/address/address.model';

export interface IBlockState extends IRootState<IBlockService> {
  detailActivityStatus?: ActivityStatus;
  statisticActivityStatus?: ActivityStatus;
  blocks?: BlockDto[];
  block?: IBlock;
  blockParameter?: IBlockParameter;
  blockEntityParameter?: IBaseFilterParameter | { q: string };
  currentBlock: IBlockListingViewModel;
  blockCurrentId?: number | null;
  blockApartmentSidebarTickets?: ITicketListingViewModel[];
  blockApartmentInProcessTickets?: ITicketListingViewModel[];
  pagination?: IPagination;
  statisticData?: {
    averageResolutionTime: string,
    chartsByDay: {
      amountTicketReported: number,
      amountTicketResolved: number,
      date: string
    }[]
  }
}

export class BlockState extends RootState implements IBlockState {
  /**
   *
   */
  detailActivityStatus?: ActivityStatus;
  statisticActivityStatus?: ActivityStatus;
  blocks: BlockDto[];
  block: IBlock;
  currentBlock: IBlockListingViewModel;
  blockParameter: IBlockParameter;
  blockCurrentId: number | null;
  blockApartmentSidebarTickets?: ITicketListingViewModel[];
  blockApartmentInProcessTickets?: ITicketListingViewModel[];
  pagination?: IPagination
  statisticData?: {
    averageResolutionTime: string,
    chartsByDay: {
      amountTicketReported: number
      amountTicketResolved: number
      date: string
    }[]
  }
  blockEntityParameter?: IBaseFilterParameter | { q: string };

  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.blocks = [];
    this.block= new BlockDto({
      managers: [],
      address: new AddressDto
     })
    this.statisticActivityStatus = ActivityStatus.NoActivity;
    this.detailActivityStatus = ActivityStatus.NoActivity;
    this.currentBlock = {}
    this.service = new BlockService;
    this.blockParameter = new BlockParameter({
      orderKeys: ['name', 'city', 'totalApartment','totalInProgressTicket'],
      orderValues: [1, 1, -1, -1],
      $limit: 100,
      key: ''
    });
    this.blockCurrentId = null;
    this.blockApartmentSidebarTickets = [];
    this.blockApartmentInProcessTickets = [];
    this.pagination = new Pagination({ total: 0, skip: 0, limit: 100 });
    this.statisticData = {
      averageResolutionTime: null,
      chartsByDay: []
    }
    this.blockEntityParameter = {
      $skip: 0,
      $limit: 10,
      q: ''
    }
    this.loaders= new Map([
      [BLOCK_LOADERS.LIST,false],
      [BLOCK_LOADERS.INFOS,false],
      [BLOCK_LOADERS.DOCUMENTS,false],
      [BLOCK_LOADERS.CHARTS, false],
      [BLOCK_LOADERS.TICKETS,false],
      [BLOCK_LOADERS.FILTER,false],
      [BLOCK_LOADERS.CONTACT,false],
      [BLOCK_LOADERS.MAINTENANCE,false]
    ])
  }
}



// WEBPACK FOOTER //
// ./src/store/block/block-state.store.ts